<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Ticket-Income-Distribution-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid>
            <v-card flat>
              <v-form ref="formdagrapor" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-card flat>
                      <v-layout row wrap>
                        <v-flex pl-1 xs12 sm6 pt-1 md2>
                          <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                            :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                            v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-1 sm6 md2>
                          <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                            :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                            v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                        </v-flex>
                        <v-flex xs12 pt-1 sm6 md4>
                          <v-radio-group row v-model="Rapor.HavayoluCari" hide-details>
                            <v-radio :value="false" :label="$t('Airline-Revenue-Distribution-Report')"></v-radio>
                            <v-radio :value="true" :label="$t('Client-Revenue-Distribution-Report')"></v-radio>
                          </v-radio-group>
                        </v-flex>
                        <v-flex pt-1>
                          <v-layout>
                            <div v-if="load1">
                              <v-btn color="info" @click="getList()" fab small="" dark>
                                <v-icon>search</v-icon>
                              </v-btn>
                            </div>
                            <div v-if="progress">
                              <v-layout pt-3 align-center="">
                                <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                              </v-layout>
                            </div>
                            <v-badge color="white" :overlap="true">
                              <template v-slot:badge>
                                <v-icon v-if="filtrevarmi" large color="green">
                                  check_circle_outline </v-icon>
                              </template>

                              <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                                @click="filtrele()" color="info" fab dark>
                                <v-icon>filter_list</v-icon>
                              </v-btn>
                              <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                <span> {{$t('Add-Search-Filter')}} </span>
                              </v-tooltip>



                            </v-badge>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-container>


          <v-container fluid="">
            <v-card flat>
              <v-layout row wrap>


                <v-flex xs12 sm12 md12>
                  <template v-for="item in itemsana">

                    <v-layout row wrap v-bind:key="item.id">

                      <v-flex
                        v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl "
                        xs12 sm12 md12>
                        <v-layout column="" fill-height="" row align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        <v-flex v-if="item.tip== 'havayolu'" xs12 sm12 md12>
                                          <v-chip label color="white" text-color="pink">
                                            <v-icon color="pink" left>flight</v-icon> <span> {{item.Title}} </span>
                                          </v-chip>
                                        </v-flex>
                                        <v-flex v-if="item.tip== 'cari'" xs12 sm12 md12>
                                          <v-chip label color="white" text-color="pink">
                                            <v-icon color="pink" left>person</v-icon> <span> {{item.Title}} </span>
                                          </v-chip>
                                        </v-flex>

                                      </v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>

                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Ticket') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Tax
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Total')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Service')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Reserve') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Discount') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Profit') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  %
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Net') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                    <span class="body-1 font-weight-">
                                      Sal.
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 pr-1 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                    <span class="body-1 font-weight-">
                                      Ret.
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider light></v-divider>

                          <v-layout>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-">
                                   {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.BiletTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.VergiTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.ToplamTutar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.KomisyonTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.ServisTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.ReserveTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.IskontoTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.Kar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.NetTutar | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row wrap justify-center="" fill-height="">
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.ichat.SatisAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 pr-1 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.ichat.IadeAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <v-divider light></v-divider>

                          <v-layout>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.BiletTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.VergiTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.ToplamTutar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.KomisyonTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.ServisTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.ReserveTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.IskontoTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.Kar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.NetTutar | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row wrap justify-center="" fill-height="">
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="">
                                    <span class="caption font-weight-thin">
                                      {{item.dishat.SatisAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout pr-1 align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.dishat.IadeAdet}} &nbsp; </span>
                                  </v-layout>

                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <v-divider light></v-divider>

                          <v-layout>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-">
                                  {{$t('Total')}}:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.BiletTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.VergiTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.ToplamTutar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.KomisyonTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.ServisTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.ReserveTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.IskontoTutari | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.Kar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.NetTutar | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row wrap justify-center="" fill-height="">
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.geneltoplam.SatisAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 pr-1 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.geneltoplam.IadeAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                        </v-card>
                      </v-flex>


                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Ticket-Amount')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                       {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.BiletTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.BiletTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}}:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.BiletTutari}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Tax-v2') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                       {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.VergiTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.VergiTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.VergiTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Total')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('Domestic-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.ToplamTutar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.ToplamTutar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.ToplamTutar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.KomisyonTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.KomisyonTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.KomisyonTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Service')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.ServisTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.ServisTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.ServisTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Reserve') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.ReserveTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.ReserveTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.ReserveTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Discount') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.IskontoTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.IskontoTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.IskontoTutari | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Profit')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                       {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.Kar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.Kar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.Kar | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Percentage') }}  %
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                       {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Net') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.NetTutar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.NetTutar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.NetTutar | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold">
                                   {{ $t('Sales-Amount') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold">
                               {{$t('Number-of-Refunds')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Domestic-Line')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('International-Line') }} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{$t('Total')}} :
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                    <v-divider :key="item.id"></v-divider>
                  </template>


                </v-flex>


                <v-layout row wrap>
                  <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" ma-2 xs12
                    sm12 md12>
                    <v-layout align-center="" justify-center="" fill-height="">
                      <span class="title grey--text font-weight-bold">
                        {{ $t('General-Totals') }}
                      </span>
                    </v-layout>
                  </v-flex>

                  <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12 sm12
                    md12>
                    <v-card flat="" class="grey--text">
                      <v-layout>

                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{ $t('Ticket') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{ $t('Tax-v2') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{$t('Total')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{ $t('Commission') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{$t('Service')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{$t('Reserve') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{ $t('Discount') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{$t('Profit')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              %
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              {{ $t('Net') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-end="" fill-height="" row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                <span class="body-1 font-weight-">
                                 Sal.
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                <span class="body-1 font-weight-">
                                 Ret.
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>

                      <v-layout>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-">
                              {{$t('Domestic-Line')}} :
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.BiletTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.VergiTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.ToplamTutar}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.KomisyonTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.ServisTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.ReserveTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.IskontoTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.Kar}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.KarYuzde}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.NetTutar}}{{getparabirimi()}} </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" row wrap justify-center="" fill-height="">
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{genic.SatisAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{genic.IadeAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-divider light></v-divider>

                      <v-layout>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-">
                              {{ $t('International-Line') }} :
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.BiletTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.VergiTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.ToplamTutar}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.KomisyonTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.ServisTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.ReserveTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.IskontoTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.Kar}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.KarYuzde}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.NetTutar}}{{getparabirimi()}} </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" row wrap justify-center="" fill-height="">
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="">
                                <span class="caption font-weight-thin">
                                  {{gendis.SatisAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{gendis.IadeAdet}} &nbsp; </span>
                              </v-layout>

                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-divider light></v-divider>

                      <v-layout>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-">
                              {{$t('Total')}} :
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.BiletTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.VergiTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.ToplamTutar}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.KomisyonTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.ServisTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.ReserveTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.IskontoTutari}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.Kar}}{{getparabirimi()}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.KarYuzde}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.NetTutar}}{{getparabirimi()}} </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" row wrap justify-center="" fill-height="">
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{gengen.SatisAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{gengen.IadeAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                    </v-card>
                  </v-flex>

                  <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                    <v-card class="grey--text">
                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <v-chip color="green"> <span class="subheading white--text"> {{ $t('General-Totals') }}
                              </span>
                            </v-chip>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{$t('Ticket-Amount')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.BiletTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.BiletTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.BiletTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{ $t('Tax-v2') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.VergiTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.VergiTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.VergiTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{$t('Total')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.ToplamTutar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.ToplamTutar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.ToplamTutar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{$t('Commission')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.KomisyonTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.KomisyonTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.KomisyonTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{$t('Service')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.ServisTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.ServisTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.ServisTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold">  {{$t('Reserve') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.ReserveTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.ReserveTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.ReserveTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{ $t('Discount') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.IskontoTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.IskontoTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.IskontoTutari}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{ $t('Profit') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.Kar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.Kart}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.Kar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{ $t('Percentage') }} %
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> {{ $t('Net') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.NetTutar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.NetTutar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.NetTutar}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold">
                              {{ $t('Sales-Amount') }}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.SatisAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.SatisAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.SatisAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold">
                             {{$t('Number-of-Refunds')}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Domestic-Line')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.IadeAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{ $t('International-Line') }} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.IadeAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  {{$t('Total')}} :
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.IadeAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                      </v-layout>

                    </v-card>
                  </v-flex>

                </v-layout>


                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                  :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                  v-model="snackbar">
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                </v-snackbar>
                <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
                  <v-card color="grey lighten-5">
                    <v-card-title> {{ $t('Filter-selection') }} </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-layout row="" wrap="">

                        <div class="flex md12">
                          <v-autocomplete v-show="hygelir" hide-details="" tabindex="2" v-model="Rapor.HavaYoluKodu"
                            :items="itemsairlinelist" clearable item-text="Title" item-value="HavaYoluKodu"
                            :label="$t('Airline-Code')"></v-autocomplete>

                          <cariaracomp v-show="musterigelir" v-bind:etiket="$t('Choose-Client')" :loading="loading" v-bind:value="Rapor.CariKodu" v-model="Rapor.CariKodu"></cariaracomp>

                          <v-autocomplete :items="hesapgurubu" hide-details="" multiple=""
                            v-model="Rapor.IstenilenHesapGrub" :label="$t('Account-Group-Requested')" item-text="Title"
                            item-value="Kod" max-height="400"></v-autocomplete>
                          <v-autocomplete :items="hesapgurubu" hide-details="" multiple=""
                            v-model="Rapor.IstenmeyenHesapGrub" :label="$t('Account-Group-Not-Requested')" item-text="Title"
                            item-value="Kod" max-height="400"></v-autocomplete>

                          
                          <cariaracomp v-show="musterigelir" v-bind:etiket="$t('Select-Main-Account')" :loading="loading" v-bind:value="Rapor.AnaHesap" v-model="Rapor.AnaHesap"></cariaracomp>


                          <v-autocomplete hide-details="" v-model="Rapor.Masraf" :items="masrafmerkezi"
                            :label="$t('Expense-Center-v2')" item-text="Title" clearable item-value="Code" max-height="400">
                          </v-autocomplete>
                        </div>
                        <div class="flex md12">
                          <div class="card__text grey darken-1 white--text">
                            <h3>{{$t('Options')}}</h3>
                          </div>
                          <v-checkbox :label="$t('Take-Purchase-Service-Service')" hide-details="" v-model="Rapor.AlisServisDus"
                            vhide-details=""></v-checkbox>
                          <v-checkbox :label="$t('VAT-Deducted')" v-model="Rapor.KdvDusulmus" hide-details=""></v-checkbox>
                          <v-checkbox :label="$t('Summary')" v-model="Rapor.DetayOzet" hide-details=""></v-checkbox>
                          <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                        </div>
                      </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-card>
          </v-container>


        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'


  export default {
    data() {
      return {
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        satisIc: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        search: '',

        genic: {
          BiletTutari: 0,
          VergiTutari: 0,
          ToplamTutar: 0,
          KomisyonTutari: 0,
          ServisTutari: 0,
          ReserveTutari: 0,
          IskontoTutari: 0,
          Kar: 0,
          KarYuzde: 0,
          NetTutar: 0,
          SatisAdet: 0,
          IadeAdet: 0
        },

        gendis: {
          BiletTutari: 0,
          VergiTutari: 0,
          ToplamTutar: 0,
          KomisyonTutari: 0,
          ServisTutari: 0,
          ReserveTutari: 0,
          IskontoTutari: 0,
          Kar: 0,
          KarYuzde: 0,
          NetTutar: 0,
          SatisAdet: 0,
          IadeAdet: 0

        },

        gengen: {
          BiletTutari: 0,
          VergiTutari: 0,
          ToplamTutar: 0,
          KomisyonTutari: 0,
          ServisTutari: 0,
          ReserveTutari: 0,
          IskontoTutari: 0,
          Kar: 0,
          KarYuzde: 0,
          NetTutar: 0,
          SatisAdet: 0,
          IadeAdet: 0

        },


        valid: true,
        itemsana: [],
        Rapor: {
          HavayoluCari: false,
          SirketKodu: null,
          KesenKisi: null,
          CariKodu: null,
          HavaYoluKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          AnaHesap: null,
          IstenilenHesapGrub: [],
          IstenmeyenHesapGrub: [],
          Masraf: null,
          KdvDusulmus: false,
          DetayOzet: false,
          AlisServisDus: false
        },

        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        hygelir: false,
        musterigelir: false,
        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        moneyformatted: '',
        date2: null,
        menu2: false,
        moneyformatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        statecari1: [],
        searchcari: '',
        progress: false,
        searchcari1: null,
        yok: false,
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
     beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
       this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });
      } 
    },

    components: {
      'tarihcomp': tarihcomp,
      yetkidialog,
      cariaracomp
    },
    watch: {
      'Rapor.HavayoluCari': function () {
        if (this.Rapor.HavayoluCari == true) {
          this.hygelir = false
          this.musterigelir = true
          this.Rapor.HavaYoluKodu = null
        } else {
          this.musterigelir = false
          this.hygelir = true
          this.Rapor.CariKodu = null
          this.Rapor.AnaHesap = null
        }
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {
          getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
    computed:{
        headers(){
          return[{
          text: this.$t('Airline-Details'),
          value: 'Title'
        }]
        },

        headersdetay(){
          return [{
            text: this.$t('Ticket-Type'),
            value: 'labeller',
            width: "1%",
            class: "background-color:red;"
          },
          {
            text: this.$t('Ticket'),
            value: 'BiletTutari'
          },
          {
            text: this.$t('Tax-v2'),
            value: 'VergiTutari'
          },
          {
            text: this.$t('Total'),
            value: 'ToplamTutar'
          },
          {
            text: this.$t('Commission'),
            value: 'KomisyonTutari'
          },
          {
            text: this.$t('Service'),
            value: 'ServisTutari'
          },
          {
            text: this.$t('Reserve'),
            value: 'ReserveTutari'
          },
          {
            text: this.$t('Discount'),
            value: 'IskontoTutari'
          },
          {
            text: this.$t('Profit'),
            value: 'Kar'
          },
          {
            text: this.$t('Percentage'),
            value: 'KarYuzde'
          },
          {
            text: this.$t('Net'),
            value: 'NetTutar'
          },
          {
            text: this.$t('Sales-Amount'),
            value: 'SatisAdet'
          },
          {
            text: 'Iade Adet',
            value: 'IadeAdet'
          }
        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.Rapor.SirketKodu = null;
    this.Rapor.KesenKisi = null;
    this.Rapor.AlisServisDus = false,
    this.Rapor.CariKodu = null;
    this.Rapor.HavaYoluKodu = null;
    this.Rapor.AnaHesap = null;
    this.Rapor.Masraf = null;
    this.Rapor.KdvDusulmus = false;
    this.Rapor.DetayOzet = false;
    this.dialogfiltre = false;
    this.tumsirketler = false;
  }

  function getList() {
    if (this.$refs.formdagrapor.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/IncomeDistReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemsana = [];

          if (response.body.Detay.length > 0) {

            response.body.Detay.forEach(element => {
              // var ListHavaYolu = [];
              var yenihavayoluyedek = [];



              var ichat = {

                BiletKarYuzde: element.DetayIcHatToplamlar.KarYuzde,
                BiletTutari: element.DetayIcHatToplamlar.BiletTutari,
                IadeAdet: element.DetayIcHatToplamlar.IadeAdet,
                IskontoTutari: element.DetayIcHatToplamlar.IskontoTutari,
                Kar: element.DetayIcHatToplamlar.Kar,
                KarYuzde: element.DetayIcHatToplamlar.KarYuzde,
                KomisyonTutari: element.DetayIcHatToplamlar.KomisyonTutari,
                NetTutar: element.DetayIcHatToplamlar.NetTutar,
                ReserveTutari: element.DetayIcHatToplamlar.ReserveTutari,
                SatisAdet: element.DetayIcHatToplamlar.SatisAdet,
                ServisTutari: element.DetayIcHatToplamlar.ServisTutari,
                ToplamTutar: element.DetayIcHatToplamlar.ToplamTutar,
                VergiTutari: element.DetayIcHatToplamlar.VergiTutari,
              }

              var dishat = {

                BiletKarYuzde: element.DetayDisHatToplamlar.KarYuzde,
                BiletTutari: element.DetayDisHatToplamlar.BiletTutari,
                IadeAdet: element.DetayDisHatToplamlar.IadeAdet,
                IskontoTutari: element.DetayDisHatToplamlar.IskontoTutari,
                Kar: element.DetayDisHatToplamlar.Kar,
                KarYuzde: element.DetayDisHatToplamlar.KarYuzde,
                KomisyonTutari: element.DetayDisHatToplamlar.KomisyonTutari,
                NetTutar: element.DetayDisHatToplamlar.NetTutar,
                ReserveTutari: element.DetayDisHatToplamlar.ReserveTutari,
                SatisAdet: element.DetayDisHatToplamlar.SatisAdet,
                ServisTutari: element.DetayDisHatToplamlar.ServisTutari,
                ToplamTutar: element.DetayDisHatToplamlar.ToplamTutar,
                VergiTutari: element.DetayDisHatToplamlar.VergiTutari,
              }

              var geneltoplam = {

                BiletKarYuzde: element.DetayGenelHatToplamlar.KarYuzde,
                BiletTutari: element.DetayGenelHatToplamlar.BiletTutari,
                IadeAdet: element.DetayGenelHatToplamlar.IadeAdet,
                IskontoTutari: element.DetayGenelHatToplamlar.IskontoTutari,
                Kar: element.DetayGenelHatToplamlar.Kar,
                KarYuzde: element.DetayGenelHatToplamlar.KarYuzde,
                KomisyonTutari: element.DetayGenelHatToplamlar.KomisyonTutari,
                NetTutar: element.DetayGenelHatToplamlar.NetTutar,
                ReserveTutari: element.DetayGenelHatToplamlar.ReserveTutari,
                SatisAdet: element.DetayGenelHatToplamlar.SatisAdet,
                ServisTutari: element.DetayGenelHatToplamlar.ServisTutari,
                ToplamTutar: element.DetayGenelHatToplamlar.ToplamTutar,
                VergiTutari: element.DetayGenelHatToplamlar.VergiTutari,
              }

              if (element.Havayolu != null) {
                yenihavayoluyedek = {
                  tip: 'havayolu',
                  HavaYoluKodu: element.Havayolu.HavaYoluKodu,
                  HavaYoluAdi: element.Havayolu.HavaYoluAdi,
                  Title: element.Havayolu.HavaYoluKodu + '-' + element.Havayolu.HavaYoluAdi,
                  ichat: ichat,
                  dishat: dishat,
                  geneltoplam: geneltoplam
                }
              } else if (element.Cari != null) {
                yenihavayoluyedek = {
                  tip: 'cari',
                  HavaYoluKodu: element.Cari.Kod,
                  HavaYoluAdi: element.Cari.Unvan,
                  Title: element.Cari.Kod + '-' + element.Cari.Unvan,
                  ichat: ichat,
                  dishat: dishat,
                  geneltoplam: geneltoplam
                }


              }

              this.itemsana.push(yenihavayoluyedek);

            });



            this.genic.BiletTutari = response.body.IcHatToplamlar.BiletTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.VergiTutari = response.body.IcHatToplamlar.VergiTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.ToplamTutar = response.body.IcHatToplamlar.ToplamTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.KomisyonTutari = response.body.IcHatToplamlar.KomisyonTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.ServisTutari = response.body.IcHatToplamlar.ServisTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.ReserveTutari = response.body.IcHatToplamlar.ReserveTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.IskontoTutari = response.body.IcHatToplamlar.IskontoTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.Kar = response.body.IcHatToplamlar.Kar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.KarYuzde = response.body.IcHatToplamlar.KarYuzde;
            this.genic.NetTutar = response.body.IcHatToplamlar.NetTutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
              '$1,');
            this.genic.SatisAdet = response.body.IcHatToplamlar.SatisAdet
            this.genic.IadeAdet = response.body.IcHatToplamlar.IadeAdet

            this.gendis.BiletTutari = response.body.DisHatToplamlar.BiletTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.VergiTutari = response.body.DisHatToplamlar.VergiTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.ToplamTutar = response.body.DisHatToplamlar.ToplamTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.KomisyonTutari = response.body.DisHatToplamlar.KomisyonTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.ServisTutari = response.body.DisHatToplamlar.ServisTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.ReserveTutari = response.body.DisHatToplamlar.ReserveTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.IskontoTutari = response.body.DisHatToplamlar.IskontoTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.Kar = response.body.DisHatToplamlar.Kar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.KarYuzde = response.body.DisHatToplamlar.KarYuzde;
            this.gendis.NetTutar = response.body.DisHatToplamlar.NetTutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
              '$1,');
            this.gendis.SatisAdet = response.body.DisHatToplamlar.SatisAdet
            this.gendis.IadeAdet = response.body.DisHatToplamlar.IadeAdet

            this.gengen.BiletTutari = response.body.GenelHatToplamlar.BiletTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.VergiTutari = response.body.GenelHatToplamlar.VergiTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.ToplamTutar = response.body.GenelHatToplamlar.ToplamTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.KomisyonTutari = response.body.GenelHatToplamlar.KomisyonTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.ServisTutari = response.body.GenelHatToplamlar.ServisTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.ReserveTutari = response.body.GenelHatToplamlar.ReserveTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.IskontoTutari = response.body.GenelHatToplamlar.IskontoTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.Kar = response.body.GenelHatToplamlar.Kar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.KarYuzde = response.body.GenelHatToplamlar.KarYuzde;
            this.gengen.NetTutar = response.body.GenelHatToplamlar.NetTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g,
              '$1,');
            this.gengen.SatisAdet = response.body.GenelHatToplamlar.SatisAdet
            this.gengen.IadeAdet = response.body.GenelHatToplamlar.IadeAdet


          } else {

            this.text1 = 'Kayıt Bulanamadı.'
            this.snackbar = true

          }
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function getListHtml() {

    if (this.$refs.formdagrapor.validate()) {

      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var lang = localStorage.getItem('lang')
      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketReport/IncomeDistReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true

          if (lang=='en')
          {
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> GELİR DAĞILIMI RAPORU </title>','<title> INCOME DISTRIBUTION REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>GELİR DAĞILIMI RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>INCOME DISTRIBUTION REPORT</font>")
             bodyhtml=bodyhtml.toString().replace("Havayolu","Airline")  
             bodyhtml=bodyhtml.toString().replace("Bilet","Ticket")  
             bodyhtml=bodyhtml.toString().replace("Toplam","Total")  
             bodyhtml=bodyhtml.toString().replace("Komisyon","Commission")  
             bodyhtml=bodyhtml.toString().replace("Servis","Service")  
             bodyhtml=bodyhtml.toString().replace("Reserve","Reserve")  
             bodyhtml=bodyhtml.toString().replace("İskonto","Discount") 
             bodyhtml=bodyhtml.toString().replace("Kar","Profit")  
             bodyhtml=bodyhtml.toString().replace("Satış Adet","Sales Count") 
             bodyhtml=bodyhtml.toString().replace("Satış Count","Sales Count")
             bodyhtml=bodyhtml.toString().replace("Iade Adet","Return Count") 
             bodyhtml=bodyhtml.toString().replaceAll("İç Hat :","Domestic line :")
             bodyhtml=bodyhtml.toString().replaceAll("Dış Hat :","International line :")
             bodyhtml=bodyhtml.toString().replaceAll("Toplam :","Total :")
             bodyhtml=bodyhtml.toString().replaceAll("Masraf :","Cost :")
             bodyhtml=bodyhtml.toString().replaceAll("Detay","Detail")
             bodyhtml=bodyhtml.toString().replaceAll("HAVAYOLUNA GÖRE","By Airlines")
             
             response.bodyText=bodyhtml;
          }

          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('incomedistribution') + ".html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }

  function getListExcel() {


    if (this.$refs.formdagrapor.validate()) {

      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketReport/IncomeDistReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('incomedistribution') + ".xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }

  function beforeMount() {

  }
</script>
<style>
</style>